import { Routes } from '@angular/router';
import { LoginComponent } from './components/user-management';
import { RegistrationComponent } from './components/user-management/registration/registration.component';
import { ForgotUsernameComponent } from './components/user-management/forgot-username/forgot-username.component';
import { ForgotPasswordComponent } from './components/user-management/forgot-password/forgot-password.component';
import HomeComponent from './components/common/home/home.component';
import {  authGuardNew, CustomerGuard, PartnerGuard } from './core/guards';
import { TrainingComponent } from './components/customer/training/training.component';
import { TrainingsInitialDtlsResolver } from './core/api/resolver/trainings/trainings-initail-dtls.resolver';
import { ProgramsResolver } from './core/api/resolver/programs/programs.resolver';
import { ChangeAccountResolver } from './core/api/resolver/user-management/change-account.resolver';
import { HealthfairResourceResolver } from './core/api/resolver/healthfair/healthfair-resource.resolver';
import { accountSalesResolver } from './core/api/resolver/accounts/account-sales.resolver';
import { AccountResolver } from './core/api/resolver/account/account.resolver';
import { FeedbackResolver } from './core/api/resolver/feedback/feedback.resolver';
import { UserDtlsResolver } from './core/api/resolver/partners-accounts/users/user-dtls.resolver';
import { ResetPasswordResolver } from './core/api/resolver/user-management/reset-password.resolver';

export const routes: Routes = [
  {
    path: "",
    redirectTo: "/login",
    pathMatch: "full"
  },
  {
    path: "login",
    component: LoginComponent,
  },
  {
    path: "registration",
    component: RegistrationComponent,
  },
  {
    path: "forgot-username",
    component: ForgotUsernameComponent,
  },
  {
    path: "forgot-password",
    component: ForgotPasswordComponent,
  },
  {
    path: "home",
    component: HomeComponent,
    canActivate: [authGuardNew("session")],
    loadChildren: () => import("./components/common/routes"),
  },
  {
    path: 'customer/promotions',
    canActivate: [authGuardNew("customer")],
    loadComponent: () => import("./components/promotions/customer-promotions/customer-promotions.component").then(m => m.CustomerPromotionsComponent),
  },
  {
    path: 'partner/communicationsdata',
    canActivate: [authGuardNew("partner")],
    loadComponent: () => import("./components/communications/customer-communications/customer-communications.component").then(m => m.CustomerCommunicationsComponent),
    data: { from: 'partner' },
  },
  {
    path: 'partner/promotionsdata',
    canActivate: [authGuardNew("partner")],
    loadComponent: () => import("./components/promotions/customer-promotions/customer-promotions.component").then(m => m.CustomerPromotionsComponent),
    data: { from: 'partner' },
  },
  {
    path: 'partner/promotions',
    canActivate: [authGuardNew("partner")],
    loadComponent: () => import("./components/promotions/partner-promotions/partner-promotions.component").then(m => m.PartnerPromotionsComponent),
  },
  {
    path: 'promotionsArchive',
    canActivate: [authGuardNew("session")],
    loadComponent: () => import("./components/promotions/promotions-archive/promotions-archive.component").then(m => m.PromotionsArchiveComponent)
  },
  {
    path: 'customer/communications',
    canActivate: [authGuardNew("customer")],
    loadComponent: () => import("./components/communications/customer-communications/customer-communications.component").then(m => m.CustomerCommunicationsComponent),
  },
  {
    path: 'partner/communications',
    canActivate: [authGuardNew("partner")],
    loadComponent: () => import("./components/communications/partner-communications/partner-communications.component").then(m => m.PartnerCommunicationsComponent),
  },
  {
    path: 'training',
    canActivate: [authGuardNew("session")],
    component: TrainingComponent,
    resolve:{
      initialDtls: TrainingsInitialDtlsResolver,
    }
  },
  {
    path: 'privacyAndTerms',
    loadComponent: () => import("./components/privacy-and-terms/privacy-and-terms.component").then(m=> m.PrivacyAndTermsComponent),
  },
  {
    path: "programs",
    canActivate: [authGuardNew("partner")],
    loadComponent: () => import("./components/programs/programs.component").then(m => m.ProgramsComponent),
    resolve: {
      programs: ProgramsResolver
    }
  },
  {
    path:'changePassword',
    canActivate: [authGuardNew("session")],
    loadComponent:() => import("./components/user-management/change-password/change-password.component").then(m => m.default),

  },
  {
    path: 'changeAccount',
    canActivate: [authGuardNew("customerSuperUser")],
    loadComponent: () => import("./components/user-management/change-account/change-account.component").then(m => m.ChangeAccountComponent),
    resolve:{
      accountTree: ChangeAccountResolver
    }
  },
  {
    path: 'healthfair',
    canActivate: [authGuardNew("session")],
    resolve:{
      initialDtls:HealthfairResourceResolver,
    },
    loadComponent: ()=>import("./components/customer/healthfair/healthfair.component").then(m => m.HealthfairComponent),
  },
  {
    path: 'customer/contactUs',
    canActivate: [authGuardNew("customer")],
    loadComponent: () => import('./components/common/contact-us/contact-us.component').then(m => m.ContactUsComponent),
    data: { userType: 'customer' }
  },
  {
    path: 'partner/contactUs',
    canActivate: [authGuardNew("partner")],
    loadComponent: () => import('./components/common/contact-us/contact-us.component').then(m => m.ContactUsComponent),
    data: { userType: 'partner' }
  },
  {
    path: 'common/contactUs',
    canActivate: [authGuardNew("session")],
    loadComponent: () => import('./components/common/contact-us/contact-us.component').then(m => m.ContactUsComponent),
    data: { userType: 'common' }
  },{
    path:'account-sales',
    canActivate: [authGuardNew("session")],
    loadComponent:() => import("./components/common/account-sales/account-sales.component").then(m => m.AccountSalesComponent),
  },
  {
    path: 'accounts',
    canActivate: [authGuardNew("partner")],
    loadComponent: () => import('./components/accounts/accounts/accounts.component').then(m => m.AccountsComponent),
  },
  {
    path: 'customer/dashboard',
    canActivate: [CustomerGuard],
    loadComponent: () => import('./components/customer/dashboard/dashboard.component').then(m => m.CustomerDashboardComponent)
  },
  {
    path: 'partner/dashboard',
    canActivate: [PartnerGuard],
    loadComponent: () => import('./components/partner/dashboard/dashboard.component').then(m => m.PartnerDashboardComponent)
  },
  {
    path: 'customer/feedback',
    canActivate: [authGuardNew("customer")],
    loadComponent: () => import('./components/common/feedback/feedback.component').then(m => m.FeedbackComponent),
    resolve:{
      feedbackData: FeedbackResolver
    }
  },
  {
    path: 'partner/feedback',
    canActivate: [authGuardNew("partner")],
    loadComponent: () => import('./components/common/feedback/feedback.component').then(m => m.FeedbackComponent),
    resolve:{
      feedbackData: FeedbackResolver
    }
  },
  {
    path: 'ssoLogin',
    loadComponent: () => import('./components/user-management/sso-login/sso-login.component').then(m => m.SsoLoginComponent)
  },
  {
    path: 'ssoAccessDenied',
    loadComponent: () => import('./components/user-management/sso-access-request/sso-access-request.component').then(m => m.SsoAccessRequestComponent)
  },
  {
    path: 'accounts/users/:salesOfficeId',
    canActivate: [authGuardNew("session")],
    loadComponent: () => import("./components/partner/accounts/users/user-home/user-home.component").then(m => m.UserHomeComponent),
  },
  {
    path: 'accounts/users',
    canActivate: [authGuardNew("session")],
    loadComponent: () => import("./components/partner/accounts/users/user-home/user-home.component").then(m => m.UserHomeComponent),
  },
  {
    path: 'accounts/usersForm',
    canActivate: [authGuardNew("session")],
    loadComponent: () => import("./components/partner/accounts/users/user-form/user-form.component").then(m => m.UserFormComponent),
  },
  {
    path: 'events/my-events',
    canActivate: [authGuardNew("session")],
    loadComponent: () => import("./components/events/my-events/my-events.component").then(m => m.MyEventsComponent),
  },
{
    path: 'accountReset',
    loadComponent: () => import("./components/user-management/reset-passowrd/reset-password.component").then(m => m.ResetPasswordComponent),
    resolve:{
      resetPasswordInit: ResetPasswordResolver
    }
  },
  {
    path: 'healthStatus',
    loadComponent: () => import("./components/site-monitor/site-monitor.component").then(m => m.SiteMonitorComponent),
  }
];
